import { CovidTestResultAdPage } from 'src/app/pages/covid-test-result-ad/covid-test-result-ad.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: CovidTestResultAdPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CovidTestResultAdPageRoutingModule {}
